import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m7.276 18.934 10.903-5.67a1.408 1.408 0 0 0 0-2.529L7.276 5.065c-1.01-.524-2.244.17-2.244 1.266v11.338c0 1.095 1.234 1.79 2.244 1.265m12.358-3.14c3.155-1.64 3.155-5.948 0-7.588L8.731 2.536C5.701.96 2 3.047 2 6.332v11.338c0 3.285 3.7 5.37 6.731 3.794z",
      class: "hidden joe-be:block joe:block qmusic:block",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M22 11.72 2 22.44V1z",
      class: "hidden willy:block",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }